module.exports = __webpack_public_path__ + "static/img/67 (1).5ba00ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/67 (1).jpg
// module id = W0Wx
// module chunks = 0